// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const ROOT_URL = 'https://lci-user-app-uat.azurewebsites.net/';
export const environment = {
  production: false,
  auth_authority: 'https://lci-auth-app-uat.azurewebsites.net/',
  apiUrl: 'https://lci-user-api-uat.azurewebsites.net/',
  auth_redirect_uri: ROOT_URL + '/auth-callback',
  auth_silent_redirect_uri: ROOT_URL + '/silent-refresh.html',
  configApi: 'https://lci-config-api-uat.azurewebsites.net/',
  auth_client_id: 'js',
  auth_post_logout_redirect_uri: ROOT_URL + '/signout',
  googleAnalyticsId: 'UA-93183220-3',
  gtmTrackingID:"GTM-5WX3QJV"
};
